import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject, OnInit,
    ViewEncapsulation
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { KAL_DIALOG_DATA, KalDialogRef } from '@kalidea/kaligraphi';
import { tap } from 'rxjs/operators';
import { MailService } from 'src/app/_core/services/mail.service';
import { BaseComponent } from 'src/app/_core/tools/base.component';
import { SharedMail } from 'src/app/_shared/components/mail/shared-mail/shared-mail.component';
import { FormValidator } from 'src/app/validators/form-validator';

export class SharedMailPreviewDialogData {
    mail: SharedMail;
    beneficiaryId: number;
}

@Component({
    selector: 'app-shared-mail-preview-dialog',
    templateUrl: './shared-mail-preview-dialog.component.html',
    styleUrls: ['./shared-mail-preview-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedMailPreviewDialogComponent extends BaseComponent implements OnInit {

    destinationMailFormControl = new FormControl<string | null>(null, [FormValidator.isNotNull, Validators.email]);

    constructor(protected readonly cdr: ChangeDetectorRef,
                @Inject(KAL_DIALOG_DATA) public readonly data: SharedMailPreviewDialogData,
                private readonly mailService: MailService,
                private readonly dialogRef: KalDialogRef<SharedMailPreviewDialogComponent>) {
        super(cdr);
    }

    sendMail(): void {
        const {mail, beneficiaryId} = this.data;

        this.watch$ = this.wrapLoader$(this.mailService.sendUserPublipostageMail$({
            mail,
            idTypePubli: mail.publipostageTypeId,
            beneficiaryId,
            destinationMail: this.destinationMailFormControl.value
        }).pipe(
            tap(() => this.dialogRef.close())
        ));
    }

    close(): void {
        this.dialogRef.close();
    }

    ngOnInit(): void {
        this.watch$ = this.mailService.loading$.pipe(
            tap(loading => this.loading = loading)
        );
    }
}
